<template>
    <div class="row">
        <div class="col">
            <card class="error" v-if="producerOrder.canceled_at">
                <card-content>
                    <span class="subtitle-1"><translate>Dieser Auftrag wurde storniert</translate></span>
                </card-content>
            </card>
            <card v-if="!producerOrder.canceled_at">
                <card-header>
                    <card-title v-if="!producerOrder.accepted_at"><translate>Bestellung bestätigen</translate></card-title>
                    <card-title v-if="producerOrder.accepted_at"><translate>Bestellung bestätigt</translate></card-title>
                </card-header>
                <card-content>
                    <description-group grid="true" v-if="!producerOrder.accepted_at">
                        <description-element :caption="producerOrder.amount +' '+ this.$gettext('Stück')"
                                             :title="this.$gettext('Bauteile')"/>
                        <description-element :caption="producerOrder.price" is-currency="true"
                                             :title="this.$gettext('Auftragspreis (netto inkl. Versandkosten)')"/>
                        <description-element :caption="shippingDate"
                                             :title="this.$gettext('geplanter Versandtermin')"/>
                        <description-element :caption="producerOrder.delivery_date" is-date="true"
                                             :title="this.$gettext('Liefertermin, spätestens bis zum')"/>

                        <description-element :caption="producerOrder.created_at" is-date="true" :title="this.$gettext('Bestelldatum')"/>

                        <description-element :caption="maxConfirmOrderDate" :title="this.$gettext('Bestätigen bis')"
                                             v-if="!producerOrder.accepted_at"/>

                        <description-element :caption="producerOrder.accepted_at" is-date="true" :title="this.$gettext('Bestätigt am')"
                                             v-if="producerOrder.accepted_at"/>
                    </description-group>

                    <hr v-if="!producerOrder.accepted_at">

                    <form @submit.prevent="confirmOrder" v-if="!producerOrder.accepted_at">
                        <form-button color="secondary" class="btn--block"><translate>Bestellung bestätigen</translate></form-button>
                    </form>

                    <div class="row" v-if="producerOrder.accepted_at">
                        <div class="col col-6">
                            <description-group grid="true">
                                <description-element :caption="producerOrder.amount +' '+ this.$gettext('Stück')"
                                                     :title="this.$gettext('Bauteile')"/>
                                <description-element :caption="producerOrder.price" is-currency="true"
                                                     :title="this.$gettext('Auftragspreis (netto inkl. Versandkosten)')"/>
                                <description-element :caption="shippingDate"
                                                     :title="this.$gettext('geplanter Versandtermin')"/>
                                <description-element :caption="deliveryDate"
                                                     :title="this.$gettext('Liefertermin, spätestens bis zum')"/>

                                <description-element :caption="producerOrder.created_at" is-date="true" :title="this.$gettext('Bestelldatum')"/>

                                <description-element :caption="maxConfirmOrderDate" :title="this.$gettext('Bestätigen bis')"
                                                     v-if="!producerOrder.accepted_at"/>

                                <description-element :caption="producerOrder.accepted_at" is-date="true" :title="this.$gettext('Bestätigt am')"
                                                     v-if="producerOrder.accepted_at"/>
                            </description-group>
                        </div>
                        <div class="col col-6" >
                            <form @submit.prevent="setOrderStatus">
                                <form-select id="producer_status" :label="this.$gettext('Auftragsstatus')" :options="producerStatus"
                                             v-model="statusForm.producer_status" :error="statusForm.errors.producer_status"
                                             @change="setOrderStatus"/>
                            </form>
                            <form-datepicker v-model:date="productionStartForm.planned_production_start_at" @update:date="setOrderPlannedProductionStart"
                                             allow-holidays="true" allow-weekends="true"
                                             :label="this.$gettext('geplanter Produktionsstart')" :min-date="producerOrder.created_at" />
                        </div>
                    </div>

                    <hr v-if="producerOrder.accepted_at">

                    <div class="row" v-if="producerOrder.accepted_at">
                        <div class="col col-6">
                            <label><translate>Warenbegleitschein</translate></label>
                            <card class="card--outline card--dense">
                                <card-content>
                                    <p>
                                        <translate>Legen Sie den <strong>ausgedruckten Warenbegleitschein</strong> bitte
                                            ihrer Lieferung bei. Damit kann PART FACTORY ihre Sendung schneller und
                                            fehlerfrei zuordnen. Beachten Sie außerdem unsere Hinweise zur Bestellung.
                                        </translate>
                                    </p>
                                    <div style="display: none;">
                                        <form-link-button
                                            :href="this.$$route('order.consignment-bill', {'producerOrder': producerOrder.id})">
                                            Preview
                                        </form-link-button>
                                    </div>
                                    <a :href="this.$$route('order.consignment-bill.pdf', {'producerOrder': producerOrder.id})"
                                       target="_blank" class="btn btn--secondary btn--block">
                                        <translate>Download</translate>
                                    </a>

                                </card-content>
                            </card>
                        </div>
                        <div class="col col-6">
                            <form-drop-zone field="ask_for_quote_document" fileSize="2MB" fileType=".pdf"
                                            maxFiles="1"
                                            uploadTarget="order.producer-bill.upload"
                                            deleteTarget="order.producer-bill.delete"
                                            :data="{'producerOrder': producerOrder.id, 'producer_file' : '1'}"
                                            :currentFile="producerBillFile"
                                            :error="errors?.ask_for_quote_document"
                                            @uploadedFiles="uploadedFiles" ask-for-quote-document="1">
                                <template v-slot:label>
                                    <translate>Rechnung</translate>
                                </template>
                                <template v-slot:textDrag>
                                    <translate>Legen Sie die PDF-Dateien hier ab<br/>&nbsp;</translate>
                                </template>
                                <template v-slot:textReplace>
                                    <translate>
                                        Legen Sie die PDF-Dateien hier ab um die bestehende zu
                                        ersetzen<br/>&nbsp;
                                    </translate>
                                </template>
                                <template v-slot:textdefault>
                                    <translate>
                                        Hochzuladende PDF-Dateien hierhin ziehen<br/>
                                        oder nach Dateien suchen (max. 2MB)
                                    </translate>
                                </template>
                            </form-drop-zone>
                        </div>
                    </div>
                </card-content>
            </card>
            <card  v-if="producerOrder.accepted_at && !producerOrder.canceled_at">
                <card-header>
                    <card-title>
                        <translate>Lieferverzögerung melden</translate>
                    </card-title>
                </card-header>
                <card-content>
                    <div class="row">
                        <div class="col col-6">
                            <p>
                                <translate>Sie können den angebotenen Liefertermin doch nicht einhalten? Hier können Sie
                                    es direkt und schnellstmöglich melden und realistisch nachkorrigieren.
                                </translate>
                            </p>
                        </div>
                        <div class="col col-6">
                            <form-button @click="lateDeliveryModal = !lateDeliveryModal"  icon="calendar-add-circle">
                                <translate>Verzögerung melden</translate>
                            </form-button>
                            <producer-late-delivery-modal :producer-order="producerOrder" v-if="lateDeliveryModal"
                                                          @closeDialog="lateDeliveryModal = false"/>
                        </div>
                    </div>
                </card-content>
                <card-content v-if="producerLateDeliveries.length > 0">
                    <p class="caption">
                        <translate>Lieferverzögerungen</translate>
                    </p>
                    <table class="table table--stripped">
                        <thead>
                        <tr>
                            <th>
                                <translate>Datum</translate>
                            </th>
                            <th>
                                <translate>Neues Lieferdatum</translate>
                            </th>
                            <th>
                                <translate>Grund für die Lieferverzögerung</translate>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="lateDelivery in producerLateDeliveries" :key="lateDelivery.index">
                            <td>{{ this.$date(lateDelivery.created_at) }}</td>
                            <td>{{ this.$date(lateDelivery.new_delivery_date) }}</td>
                            <td>{{ lateDelivery.reason }}</td>
                        </tr>
                        </tbody>
                    </table>
                </card-content>
            </card>
        </div>
    </div>
</template>

<script>
import CardContent from '@partfactory/Shared/Card/CardContent';
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardTitle from '@partfactory/Shared/Card/CardTitle';
import DescriptionGroup from '@partfactory/Shared/Elements/DescriptionGroup';
import DescriptionElement from '@partfactory/Shared/Elements/DescriptionElement';
import FormButton from '@partfactory/Shared/Form/FormButton';
import {useForm} from '@inertiajs/vue3';
import FormSelect from '@partfactory/Shared/Form/FormSelect';
import FormLinkButton from '@partfactory/Shared/Form/FormLinkButton';
import FormDropZone from '@partfactory/Shared/Form/FormDropZone';
import ProducerLateDeliveryModal from '@partfactory/Pages/Producer/Component/Modals/ProducerLateDeliveryModal';
import FormDatepicker from '@partfactory/Shared/Form/FormDatepicker';

export default {
    name: 'ComponentOrder',
    components: {
        FormDatepicker,
        ProducerLateDeliveryModal,
        FormDropZone,
        FormLinkButton,
        FormSelect,
        FormButton,
        DescriptionElement,
        DescriptionGroup,
        CardTitle,
        CardHeader,
        Card,
        CardContent
    },
    props: {
        producerOrder: Object,
        errors: Object,
    },
    data() {
        let lateDeliveryModal = false;
        const form = useForm({});
        const statusForm = useForm({
            producer_status: this?.producerOrder?.producer_status,
        });
        const productionStartForm = useForm({
            planned_production_start_at: this?.producerOrder?.planned_production_start_at,
        });

        return {lateDeliveryModal, form, statusForm, productionStartForm};
    },
    computed: {
        producerStatus() {
            return [
                {
                    value: this.$page.props.producerStatus[0].status_id,
                    text: this.$gettext(this.$page.props.producerStatus[0].status_name)
                },
                {
                    value: this.$page.props.producerStatus[1].status_id,
                    text: this.$gettext(this.$page.props.producerStatus[1].status_name)
                },
                {
                    value: this.$page.props.producerStatus[2].status_id,
                    text: this.$gettext(this.$page.props.producerStatus[2].status_name)
                },
                {
                    value: this.$page.props.producerStatus[3].status_id,
                    text: this.$gettext(this.$page.props.producerStatus[3].status_name)
                }
            ];
        },
        producerBillFile() {
            return this.producerOrder?.producer_bill;
        },
        producerLateDeliveries() {
            return this.producerOrder?.producer_late_deliveries;
        },
        plannedProductionStartAtMinDate() {
            return this.$moment(this.producerOrder.delivery_date).subtract(this.$page.props.factors.delivery_time_producer_part, 'days').format('YYYY-MM-DD');
        },
        maxConfirmOrderDate() {
            return this.$date(this.$moment(this.producerOrder.created_at).nextBusinessDay());
        },
        shippingDate() {
            return this.producerOrder.delivery_date_corrected ? this.$moment(this.producerOrder.delivery_date_corrected).subtract(this.$page.props.factors.delivery_time_part_client, 'days').format('DD.MM.YYYY') : this.$moment(this.producerOrder.delivery_date).subtract(this.$page.props.factors.delivery_time_part_client, 'days').format('DD.MM.YYYY');
        },
        deliveryDate() {
            return this.producerOrder?.delivery_date_corrected ? this.$date(this.producerOrder?.delivery_date_corrected)+' '+this.$gettext('(korrigiert)') : this.$date(this.producerOrder.delivery_date);
        }
    },
    methods: {
        confirmOrder() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('order.confirm', {'producerOrder': this.producerOrder.id}));
        },
        setOrderStatus() {
            this.statusForm
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('order.status', {'producerOrder': this.producerOrder.id}));
        },
        setOrderPlannedProductionStart() {
            this.productionStartForm
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('order.production-start', {'producerOrder': this.producerOrder.id}));
        },
        uploadedFiles() {
            this.$inertia.reload();
        },
    },
};
</script>
